import { UrlObject } from 'url';

export const getQuestionDetailUrlObject = ({
  reportId,
  problemStatusDetailId,
}: {
  reportId: number;
  problemStatusDetailId: number;
}): UrlObject => {
  const urlString = `/my-questions/${reportId}`;
  return {
    pathname: urlString,
    query: {
      problemStatusDetailId,
    },
  };
};
